import api from './http';

// 题库相关
export async function listBanks() {
  const res = await api.get('/exams/banks');
  return res.data;
}
export async function createBank(data) {
  const res = await api.post('/exams/banks', data);
  return res.data;
}
export async function deleteBank(id) {
  const res = await api.delete(`/exams/banks/${id}`);
  return res.data;
}
export async function listQuestions(bankId) {
  const res = await api.get(`/exams/banks/${bankId}/questions`);
  return res.data;
}

export async function searchQuestions(params = {}) {
  const res = await api.get('/exams/questions/search', { params });
  return res.data;
}

export async function deleteQuestion(questionId) {
  const res = await api.delete(`/exams/questions/${questionId}`);
  return res.data;
}

// 题库组合
export async function listBankGroups() {
  const res = await api.get('/exams/bank-groups');
  return res.data;
}
export async function createBankGroup(data) {
  const res = await api.post('/exams/bank-groups', data);
  return res.data;
}
export async function updateBankGroup(id, data) {
  const res = await api.put(`/exams/bank-groups/${id}`, data);
  return res.data;
}
export async function deleteBankGroup(id) {
  const res = await api.delete(`/exams/bank-groups/${id}`);
  return res.data;
}

// 考试相关
export async function listExams() {
  const res = await api.get('/exams/exams');
  return res.data;
}
export async function createExam(data) {
  const res = await api.post('/exams/exams', data);
  return res.data;
}
export async function publishExam(id, payload = {}) {
  const res = await api.post(`/exams/exams/${id}/publish`, payload);
  return res.data;
}
export async function updateExam(id, data) {
  const res = await api.put(`/exams/exams/${id}`, data);
  return res.data;
}
export async function deleteExam(id) {
  const res = await api.delete(`/exams/exams/${id}`);
  return res.data;
}
export async function getExamQuestions(id) {
  const res = await api.get(`/exams/exams/${id}/questions`);
  return res.data;
}
export async function startAttempt(examId, payload = {}) {
  const res = await api.post(`/exams/exams/${examId}/start`, payload);
  return res.data;
}
export async function submitAttempt(attemptId, answers) {
  const res = await api.post(`/exams/attempts/${attemptId}/submit`, { answers });
  return res.data;
}
export async function saveAttemptProgress(attemptId, payload = {}) {
  const res = await api.post(`/exams/attempts/${attemptId}/progress`, payload);
  return res.data;
}
export async function getAttempt(attemptId) {
  const res = await api.get(`/exams/attempts/${attemptId}`);
  return res.data;
}
export async function getExamStats(examId) {
  const res = await api.get(`/exams/exams/${examId}/stats`);
  return res.data;
}
export async function getExamWrongQuestions(examId) {
  const res = await api.get(`/exams/exams/${examId}/wrong-questions`);
  return res.data;
}
export async function getMyExams() {
  const res = await api.get('/exams/my-exams');
  return res.data;
}
export async function deleteAttempt(attemptId) {
  const res = await api.delete(`/exams/attempts/${attemptId}`);
  return res.data;
}
export async function practice(bankIds, limit, reveal = false) {
  const res = await api.post('/exams/practice', { bank_ids: bankIds, limit, reveal });
  return res.data;
}

export async function submitPracticeSession(sessionId, answers) {
  const res = await api.post(`/exams/practice/sessions/${sessionId}/submit`, { answers });
  return res.data;
}

export async function getMyPracticeRecords() {
  const res = await api.get('/exams/practice/my-records');
  return res.data;
}

export async function getPracticeSession(sessionId) {
  const res = await api.get(`/exams/practice/sessions/${sessionId}`);
  return res.data;
}

export async function deletePracticeSession(sessionId) {
  const res = await api.delete(`/exams/practice/sessions/${sessionId}`);
  return res.data;
}

export async function importBanksExcel(file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post('/exams/banks/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
}

export async function uploadQuestionsExcel(bankId, file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post(`/exams/banks/${bankId}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
}
